// extracted by mini-css-extract-plugin
export default {"Modal":"beg_a bii_bk bii_bl bii_bm bii_bo bii_bn bii_wn","Modal__backdrop":"beg_b beg_a bii_bk bii_bl bii_bm bii_bo bii_bn bii_wn bii_ec"};